import React, { useEffect, useState } from "react";
import { Button, Modal, Popover, Table } from "antd";
import { useDeleteOrder, useOrderList } from "../../../api/order";
import { useNavigate } from "react-router-dom";
import { getStatusColor } from "../../../util/statusColor";
import AdminUdateOrderModal from "../../modals/AdminUdateOrderModal";
import { MoreOutlined } from "@ant-design/icons";
// import { MoreVertical } from "lucide";
// import AdminUdateOrderModal from '../../modals/order/AdminUdateOrderModal';

type ordersTableProps = {
  searchText: string;
};

const OrdersTable: React.FC<ordersTableProps> = ({ searchText }) => {
  const [tableData, setTableData] = useState<any[]>([]);
  const navigate = useNavigate();
  const { data: orders, isLoading } = useOrderList();
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [selectedStatus, setSelectedStatus] = useState<
    | "ACCEPTED"
    | "DELIVERED"
    | "INPROGRESS"
    | "PENDING"
    | "REJECTED"
    | "COMPLETED"
    | undefined
  >();

  const [deleteOpen, setdeleteOpen] = useState(false);
  const [deleteSelectedId, setdeleteSelectedId] = useState("");

  const { mutateAsync: deleteOrder } = useDeleteOrder();

  useEffect(() => {
    if (searchText) {
      if (orders && orders.data) {
        const _data = orders.data.filter(
          (item: any) =>
            item.orgName?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.product?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.status?.toLowerCase().includes(searchText.toLowerCase()),
        );
        setTableData(_data);
      }
    } else {
      if (orders && orders.data) {
        setTableData(orders.data);
      }
    }
  }, [searchText, orders]);

  const ordersColumn = [
    {
      title: "No.",
      width: 60,
      render: (text: string, record: any, index: number) => <b>#{index + 1}</b>,
    },
    {
      dataIndex: "orgName",
      title: "Company name",
    },
    {
      dataIndex: "product",
      title: "Product",
    },
    {
      dataIndex: "startingDate",
      title: "Start date",
    },
    {
      dataIndex: "dueDate",
      title: "Due date",
    },
    {
      dataIndex: "orderAmount",
      title: "Quantity (qt)",
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (text: string, record: any) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "80%",
              paddingTop: 6,
              paddingBottom: 6,
              borderRadius: 8.5,
              color: getStatusColor(text),
              backgroundColor: `${getStatusColor(text)}44`,
            }}
          >
            {text}
          </div>
        );
      },
    },
    {
      title: "Actions",
      render: (text: string, record: any, index: number) => (
        <div style={{ display: "flex", gap: 12 }}>
          <Button
            type="primary"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedId(record.id);
              setSelectedStatus(record.status);
              setOpen(true);
            }}
          >
            Edit
          </Button>
          {/* <Button danger style={{ backgroundColor: '#f5222d' }} onClick={(e) => {
            e.stopPropagation();
            setdeleteSelectedId(record.order_id);
            setdeleteOpen(true);
          }}>Delete</Button> */}
        </div>
      ),
    },
  ];

  const hideModal = () => {
    setOpen(false);
    setSelectedId("");
    setSelectedStatus(undefined);
  };

  const onDelete = async () => {
    if (deleteSelectedId) {
      await deleteOrder(deleteSelectedId);
    }
    setdeleteOpen(false);
  };
  return (
    <>
      <Modal
        title={<div style={{ color: "black" }}>Confirmation</div>}
        open={deleteOpen}
        centered
        onOk={onDelete}
        onCancel={() => setdeleteOpen(false)}
        closable
        style={{ color: "black" }}
      >
        Are you sure you want to delete this Order?
      </Modal>
      <AdminUdateOrderModal
        open={open}
        selectedId={selectedId}
        hideModal={hideModal}
        orderStatus={selectedStatus}
      />
      <div className="hidden md:block">
        <Table
          style={{ cursor: "pointer", 
            position: "relative",
            zIndex: 100, 
            overflowY:"hidden"
          }}
          scroll={{ y: 600 }} 
          onRow={(record, index) => {
            return {
              onClick: (event) => {
                navigate(`/orders/${record.id}`);
              },
            };
          }}
          dataSource={tableData}
          columns={ordersColumn}
          loading={isLoading}
        />
      </div>
      <div className="w-full grid grid-col divide-y-2 divide-green-400 md:hidden px-2 mb-4">
        {tableData.map((item: any) => (
          <div className="flex justify-between items-center py-2">
            <div
              className="flex flex-col gap-1 w-[95%]"
              onClick={() => {
                navigate(`/orders/${item.id}`);
              }}
            >
              <div className="flex gap-4 font-bold text-xl text-white">
                <div>{item.product}</div>
                <div>({item.orderAmount} qt)</div>
              </div>
              <div className="text-gray-300">{`${item.startingDate} - ${item.dueDate}`}</div>
              <div style={{ color: getStatusColor(item.status) }} className="">
                {item.status}
              </div>
            </div>
            <Popover
              placement="bottomLeft"
              title={<div style={{ color: "black" }}>Actions</div>}
              content={
                <div style={{ color: "black", width: 200 }}>
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedId(item.id);
                      setSelectedStatus(item.status);
                      setOpen(true);
                    }}
                    style={{
                      display: "flex",
                      gap: 12,
                      alignItems: "center",
                      borderBottom: "1px solid #eee",
                      paddingBottom: 5,
                      marginTop: 15,
                      cursor: "pointer",
                    }}
                  >
                    <div>Edit</div>
                  </div>
                </div>
              }
            >
              <MoreOutlined className="text-white" />
            </Popover>
          </div>
        ))}
      </div>
    </>
  );
};

export default OrdersTable;
